<template>

  <FormRadioGroupField v-if="question.type == ClassifierQuestionType.CHOOSE_ONE" :label="question.prompt" :options="availableAnswers" v-model="selectedSingleOption" stacked>
    <FormTextField v-if="selectedSingleOption == 'Other'" v-model="otherText" autoFocus class="pt-0" />
  </FormRadioGroupField>

  <FormCheckboxGroupField v-else-if="question.type == ClassifierQuestionType.CHOOSE_MULTI" :label="question.prompt" :options="availableAnswers" v-model="selectedMultipleOptions" stacked>
    <FormTextField v-if="selectedMultipleOptions?.includes('Other')" v-model="otherText" autoFocus trimmed class="pt-0" />
  </FormCheckboxGroupField>
  
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, computed } from "vue";
import { ClassifierQuestion, ClassifierQuestionType } from "../model";

const props = defineProps<{
  question: ClassifierQuestion,
  modelValue: string[],
}>();

const selectedSingleOption = ref<string|null>(null);
const selectedMultipleOptions = ref<string[]>([]);
const otherText = ref<string>("");

onMounted(() => {
  // Parse and initialize based on initial model value
  switch (props.question.type) {
    case ClassifierQuestionType.CHOOSE_ONE: {
      selectedSingleOption.value = props.modelValue.length == 0 ? null : decodeOption(props.modelValue[0]);
      break;
    }

    case ClassifierQuestionType.CHOOSE_MULTI: {      
      selectedMultipleOptions.value = props.modelValue.map(s => decodeOption(s));
      break;
    }
  }
});

const emit = defineEmits(['update:modelValue'])

const onChange = () => {
  if (props.question.type == ClassifierQuestionType.CHOOSE_ONE) {
    emit('update:modelValue', selectedSingleOption.value == null ? [] : [encodeOption(selectedSingleOption.value)]);
  } else {
    emit('update:modelValue', selectedMultipleOptions.value.map(s => encodeOption(s)));
  }
};

const encodeOption = (val: string) => {
  return val == "Other" ? `Other:${otherText.value}` : val;
}

const decodeOption = (val: string) => {
  if (val.startsWith("Other:")) {
    otherText.value = val.substring("Other:".length);
    return "Other";
  } else {
    return val;
  }
}

watch(selectedSingleOption, ()=>{
  onChange();  
});

watch(selectedMultipleOptions, ()=>{
  onChange();
});

watch(otherText, ()=>{
  onChange();
});

const availableAnswers = computed(() => {
  const answers:any = {};
  for (let a of props.question.answers) {
    answers[a.label] = a.id;
  }
  if (props.question.includeOtherOption) {
    answers[props.question.otherOptionLabel || "Other"] = "Other";
  }
  return answers;
})
</script>

<style lang="scss" scoped>
</style>
 